export default {
  'dataTable.rowsPerPage': 'Rows per page: ',
  'dataTable.rangeSeparatorText': 'of',
};
